function getTraceId(error) {
    return error && error.response && error.response.headers ? error.response.headers['mlp-trace-id'] : '';
}
export { getTraceId };
